import { createFileRoute } from '@tanstack/react-router';
import OrderViewContent from '../order/view/order-view-content/order-view-content';

export const Route = createFileRoute('/orders/$orderGuid/')({ component: OrderViewContent });
